import axios from 'axios'

export const emailDemo = ({name, companyName, email, web, sector}) => {
  return axios.post("https://api.ecoscooting.com:3000/email/demo", {name, companyName, email, web, sector}).then((res) => {
   return res.data
  });
};
// export const emailDemo = ({name, companyName, email, web, sector}) => {
//   return axios.post("https://staging.ecoscooting.com:4000/email/demo", {name, companyName, email, web, sector}).then((res) => {
//    return res.data
//   });
//};